import { createI18n } from 'vue-i18n';
import { get as getParam } from '../../../../utils/query'

// 导入所有语言文件
import zh_CN from './lang/zh_CN.json'
import zh_TW from './lang/zh_TW.json'
import en from './lang/en.json'
import id from './lang/id.json'
import ar from './lang/ar.json'
import tr from './lang/tr.json'
import vi from './lang/vi.json'
import pt from './lang/pt.json'
import ja from './lang/ja.json'
import ms from './lang/ms.json'
import fr from './lang/fr.json'
import es from './lang/es.json'
import de from './lang/de.json'
import th from './lang/th.json'
import ru from './lang/ru.json'


const langArr = ['ar', 'en', 'zh-CN', 'zh-TW', 'zh-HK', 'tr']

// 浏览器语言检测和映射
function getBrowserLanguage() {
  let browserLang = getParam('lang') || navigator.language || navigator.userLanguage || 'en'

  console.log('browserLang', browserLang)
  if (/\w+-\w+/.test(browserLang)) {
    const langs = browserLang.split("-");
    browserLang = `${langs[0]}-${langs[1].toUpperCase()}`;
  } else {
    browserLang = browserLang.toLowerCase()
  }
  // 语言映射表
  const langMap = {
    'zh': 'zh_CN',
    'zh-CN': 'zh_CN',
    'zh-TW': 'zh_TW',
    'zh-HK': 'zh_TW',
    'zh_CN': 'zh_CN',
    'zh_TW': 'zh_TW',
    'zh_HK': 'zh_TW',
    'en': 'en',
    'en-US': 'en',
    'en-GB': 'en',
    'en_US': 'en',
    'en_GB': 'en',
    'id': 'id',
    'id-ID': 'id',
    'id_ID': 'id',
    'ar': 'ar',
    'ar-SA': 'ar',
    'ar_SA': 'ar',
    'tr': 'tr',
    'tr-TR': 'tr',
    'tr_TR': 'tr',
    'vi': 'vi',
    'vi-VN': 'vi',
    'vi_VN': 'vi',
    'pt': 'pt',
    'pt-BR': 'pt',
    'pt_BR': 'pt',
    'ja': 'ja',
    'ja-JP': 'ja',
    'ja_JP': 'ja',
    'ms': 'ms',
    'my': 'ms',
    'ms-MY': 'ms',
    'ms_MY': 'ms',
    'fr': 'fr',
    'fr-FR': 'fr',
    'fr_FR': 'fr',
    'es': 'es',
    'es-ES': 'es',
    'es_ES': 'es',
    'de': 'de',
    'de-DE': 'de',
    'de_DE': 'de',
    'th': 'th',
    'th-TH': 'th',
    'th_TH': 'th',
    'ru': 'ru',
    'ru-RU': 'ru',
    'ru_RU': 'ru'
  }

  if (!langArr.includes(browserLang)) {
    browserLang = 'en'
  }

  // 首先尝试完整匹配
  if (langMap[browserLang]) {
    return langMap[browserLang]
  }

  // 然后尝试语言代码匹配
  const langCode = browserLang.split('-')[0]
  return langMap[langCode] || 'en'
}

// 消息对象 - 包含所有语言文件
const messages = {
  zh_CN,
  zh_TW,
  en,
  id,
  ar,
  tr,
  vi,
  pt,
  ja,
  ms,
  fr,
  es,
  de,
  th,
  ru
}

// 创建i18n实例 - Vue 3配置
const i18n = createI18n({
  legacy: false, // 启用组合式API
  globalInjection: true, // 全局注入$t等函数
  locale: getBrowserLanguage(),
  fallbackLocale: 'en',
  silentFallbackWarn: false, // 显示警告以便调试
  messages,
  missingWarn: false, // 禁用缺失键的警告
  fallbackWarn: false // 禁用回退警告
})
export default i18n
